import { CalendarIcon } from "../../assets/icons";
import { Modal } from "react-bootstrap";
import { getUserInitial } from "../../utils/otherHelopers";
import { formatMomentDate } from "../../utils/dateHelper";
import { Phone } from "lucide-react";
import withModal from "../../components/withModal";

const ViewNpaInquiries = ({ selectedInquiry }) => {
  // console.log("selectedInquiry",selectedInquiry);

  return (
    <Modal.Body>
      <div className="user-cell mb-3 px-2">
        <span className="user-initials">
          {selectedInquiry?.user ? getUserInitial(`${selectedInquiry.user.first_name || ""} ${selectedInquiry.user.last_name || ""}`) : "-"}
        </span>
        {selectedInquiry?.user ? `${selectedInquiry.user.first_name || ""} ${selectedInquiry.user.last_name || ""}`.trim() : "-"}
      </div>
      <h5 className="h6 py-1 px-2 mb-2 fw-medium rounded-2" style={{ backgroundColor: "#BCBBC14A" }}>Contact Info</h5>
      <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 mb-2 mb-xxl-4">
        <div className="g-col-6">
          <div className="d-flex align-items-start gap-2">
            <div className="rounded-2 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#9F2F481A", minWidth: "30px", aspectRatio: "1" }}>
              <CalendarIcon
                width={20}
                height={20}
                color="#9F2F48"
                strokeWidth="1.5"
              />
            </div>
            <div>
              <h6 className="h6">
                {/* 09 Feb 2020   */}
                {selectedInquiry?.created_at ? formatMomentDate(selectedInquiry?.created_at, "DD MMM YYYY") : "-"}
              </h6>
              <p className="text-capitalize fs-sm">Inquiry Created</p>
            </div>
          </div>
        </div>
        <div className="g-col-6">
          <div className="d-flex align-items-start gap-2">
            <div className="rounded-2 d-flex align-items-center justify-content-center" style={{ aspectRatio: 1, backgroundColor: "#53587A1A", minWidth: "30px" }}>
              <Phone
                width={20}
                height={20}
                color="#53587A"
                strokeWidth="1.5"
              />
            </div>
            <div>
              <h6 className="">
                {selectedInquiry?.user?.email ? selectedInquiry?.user?.email : "-"}
              </h6>
              <p className="text-capitalize fs-sm">{selectedInquiry?.user?.mobile_number ? selectedInquiry?.user?.mobile_number : "-"}</p>
            </div>
          </div>
        </div>
      </div>

      <h5 className="h6 py-1 px-2 mb-2 fw-medium rounded-2" style={{ backgroundColor: "#BCBBC14A" }}>Notes</h5>
      <p className="text-secondary fs-sm">{selectedInquiry?.message ? selectedInquiry?.message : "-"} sjda fuof uisadfkas uasidbask aoshdao dahdad madamd oiahda doid amd aD AOIDHOD ADHD ADQDN DAHD ADofds  fialf
      </p>
    </Modal.Body>
  );
};

export default withModal(ViewNpaInquiries);
